import script from "./SelectedPlatformsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectedPlatformsList.vue?vue&type=script&setup=true&lang=js"

import "./SelectedPlatformsList.vue?vue&type=style&index=0&id=f0c05978&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0c05978"]])

export default __exports__